import {h, Fragment} from "preact"
import Product from "./Product"
import QuickShop from "./QuickShop"
import useSwatches from "./useSwatches"
import { useMemo } from "preact/hooks"
import { useAppStateSelector } from "@nosto/preact"

export default function Products() {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    var { swatchData } = useSwatches();

    

    const productsToShow = products.hits.filter(hit => hit.availability === "InStock" || hit.name.includes("Gift Card"));
    
    return (
        <div class="ns-d-flex ns-flex-wrap collection-flex container" style={loading ? "opacity: 0.3;" : ""}>
            {productsToShow.map((hit, index) => {

                const groupTag = useMemo(() => hit?.tags1?.find(tag => tag.toLowerCase().includes('ygroup')), []);
                const relatedProducts = useMemo(() => {
                    if (!groupTag) return [];
                    return swatchData.filter(product =>
                        product.tags1?.some(tag =>
                          tag?.toLowerCase().includes(groupTag.toLowerCase())
                        )
                      );
                }, [swatchData, groupTag]);

                return (
                    <Product product={hit} key={hit.productId || index} relatedProducts={ relatedProducts } />
                )

            })}
        </div>
    )
}
